<template>
    <Header title="Termos de Uso" />
    <div class="flex flex-col gap-2 p-4">
        <h1>Terms of Use for iLoyal</h1>

        <p>Last Updated: September 2024</p>

        <h2>1. Acceptance of Terms</h2>

        <p>
            By accessing or using the iLoyal mobile application, you agree to be
            bound by these Terms of Use. If you do not agree to these terms,
            please do not use the app.
        </p>

        <h2>2. Description of Service</h2>

        <p>
            iLoyal is a cashback points app that allows business owners to offer
            cashback points to their customers. The app facilitates the
            management and redemption of these points.
        </p>

        <h2>3. User Accounts</h2>

        <h3>3.1 Account Creation:</h3>

        <p>
            To use iLoyal, you must create an account. You agree to provide
            accurate, current, and complete information during the registration
            process.
        </p>

        <h3>3.2 Account Responsibility:</h3>

        <p>
            You are responsible for maintaining the confidentiality of your
            account and password. You agree to accept responsibility for all
            activities that occur under your account.
        </p>

        <h2>4. User Conduct</h2>

        <p>
            You agree not to use iLoyal for any unlawful purpose or in any way
            that could damage, disable, overburden, or impair the service.
        </p>

        <h2>5. Business Owner Responsibilities</h2>

        <h3>5.1 Point Issuance:</h3>

        <p>
            Business owners are responsible for accurately issuing cashback
            points to customers in accordance with their stated policies.
        </p>

        <h3>5.2 Redemption Honoring:</h3>

        <p>
            Business owners agree to honor valid point redemptions made through
            the iLoyal app.
        </p>

        <h2>6. Intellectual Property</h2>

        <p>
            All content and functionality on iLoyal, including but not limited
            to text, graphics, logos, and software, is the property of iLoyal or
            its licensors and is protected by copyright and other intellectual
            property laws.
        </p>

        <h2>7. Limitation of Liability</h2>

        <p>
            iLoyal and its affiliates shall not be liable for any indirect,
            incidental, special, consequential, or punitive damages resulting
            from your use of or inability to use the service.
        </p>

        <h2>8. Modifications to Service</h2>

        <p>
            We reserve the right to modify or discontinue, temporarily or
            permanently, the service with or without notice.
        </p>

        <h2>9. Termination</h2>

        <p>
            We may terminate or suspend your account and access to the service
            immediately, without prior notice or liability, for any reason
            whatsoever.
        </p>

        <h2>10. Governing Law</h2>

        <p>
            These Terms shall be governed by and construed in accordance with
            the laws of [Your Jurisdiction], without regard to its conflict of
            law provisions.
        </p>

        <h2>11. Changes to Terms</h2>

        <p>
            We reserve the right to update or change these Terms at any time. We
            will provide notice of significant changes to the Terms.
        </p>

        <h2>12. Contact Information</h2>

        <p>
            If you have any questions about these Terms, please contact us at
            support@iloyal.com.
        </p>
    </div>
</template>
